import {
  ChangeDetectionStrategy,
  Component,
  HostListener,
  Inject,
  ViewEncapsulation,
} from '@angular/core';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';
import { TranslateModule } from '@ngx-translate/core';
import { IconComponent } from '@sc/ui-components';
import { SnackBarData } from '../../types/snackbar-data';

@Component({
  selector: 'sc-snackbar-notification',
  styleUrls: ['./snackbar-notification.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent, TranslateModule],
  template: `
    <div class="notification-color"></div>
    <div class="icon-container">
      <sc-icon name="info" specificName="snackbar_info_icon"></sc-icon>
    </div>
    <section
      role="alertdialog"
      aria-modal="true"
      aria-labelledby="sc-bottom-snackbar-title"
      aria-describedby="sc-bottom-snackbar-body"
    >
      <div class="top">
        <div class="title hide-focus-outline">
          <p
            id="sc-bottom-snackbar-title"
            class="sc-design-title-h2"
            role="heading"
            aria-level="1"
            tabindex="-1"
          >
            {{ data.title }}
          </p>
        </div>

        <button type="button" (click)="onCloseClick()">
          <span class="sr_only">{{
            'GlobalApplicativeConstants.accessibility.closeSnackbar' | translate
          }}</span>
          <sc-icon name="close"></sc-icon>
        </button>
      </div>
      <div class="msg">
        <p id="sc-bottom-snackbar-body" class="sc-design-text-3">
          {{ data.message }}
        </p>
      </div>
    </section>
  `,
})
export class SnackbarNotificationComponent {
  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: SnackBarData) {}

  @HostListener('document:keydown.escape')
  onCloseClick(): void {
    this.data.currentSnackBar.dismiss();
  }
}
